import React, { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import AsyncSelect from "react-select/async";
import { getIdCompany } from "../../utils/constantes";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextField from "@mui/material/TextField";
const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props, ref) => {
  const [description, setDescription] = useState(null);
  const [SAPCode, setSAPCode] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getBlocs();
    getSector();
  }, []);

  useImperativeHandle(ref, () => ({
    addSector,
    updateSector,
    deleteSector,
  }));

  const getSector = async () => {
    if (props.idSector != null) {
      setIsLoading(true);
      try {
        let response = await blogFetch.get(`/sector/${props.idSector}`);
        let data = response.data;
        setTimeout(() => {
          setDescription(data.stR_description);
          setSAPCode(data.stR_SAPCode);
          setSelectedValue(data.bloc);
          setIsLoading(false);
        }, 300);
      } catch (error) {
        console.error(error);
      }
    }
  };
  const getBlocs = async () => {
    try {
      let response = await blogFetch.get("/bloc");
      let data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const addSector = async () => {
    let blocId = null;
    if (selectedValue != null) {
      blocId = selectedValue.blC_PK_idBLoc;
    }
    let sector = {
      STR_FK_blocId: blocId,
      STR_description: description,
      STR_SAPCode: SAPCode,
      STR_FK_companyId: getIdCompany(),
    };
    try {
      const response = await blogFetch.post("/sector", sector);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const updateSector = async () => {
    let blocId = null;
    if (selectedValue != null) {
      blocId = selectedValue.blC_PK_idBLoc;
    }
    let sector = {
      STR_FK_blocId: blocId,
      STR_description: description,
      STR_SAPCode: SAPCode,
      STR_FK_companyId: getIdCompany(),
    };
    try {
      const response = await blogFetch.put("/sector/" + props.idSector, sector);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const deleteSector = async () => {
    let blocId = null;
    if (selectedValue != null) {
      blocId = selectedValue.blC_PK_idBLoc;
    }

    try {
      const response = await blogFetch.delete("/sector/" + props.idSector);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <center>
            <FontAwesomeIcon icon={faSpinner} spin />
          </center>
        </div>
      ) : (
        <div>
          <div className="mb-3">
            <TextField
              className="mb-3"
              id="outlined-basic"
              label="Nome do Setor"
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <TextField
              variant={props.idSector != null ? "filled" : "outlined"}
              id={props.idSector != null ? "Filled-basic" : "outlined-basic"}
              disabled={props.idSector != null}
              label="Código SAP"
              fullWidth
              value={SAPCode}
              onChange={(e) => setSAPCode(e.target.value)}
            />
          </div>

          <AsyncSelect
            cacheOptions
            defaultOptions
            placeholder="Bloco"
            value={selectedValue}
            getOptionLabel={(e) => e.blC_description}
            getOptionValue={(e) => e.blC_PK_idBLoc}
            loadOptions={getBlocs}
            onChange={handleChange}
          />
        </div>
      )}
    </>
  );
});
